import { privateRoutes, pflegekassenRoutes, nachbarschaftshilfeRoutes  } from './Routes/PrivateRoutes'
import { routes as publicRoutes } from './Routes/PublicRoutes'


//export { routes as adminRoutes }  from './AdminRoutes'
//export {PrivateRoutes} from './PrivateRoutes'
//export { PublicRoutes } from './PublicRoutes'
//export { AdminRoutes }  from './AdminRoutes'
const routes = {privateRoutes, publicRoutes}

export {
    nachbarschaftshilfeRoutes,
    pflegekassenRoutes,
    privateRoutes,
    publicRoutes,
    routes
}

export default routes